import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import Raven from 'raven-js';
import { useVirtualizedCellAnchor } from '../hooks/useVirtualizedCellAnchor';
export const useFindPopoverAnchorElement = t0 => {
  var _callToAction$rowInde, _callToAction$columnI;
  const $ = _c(16);
  const {
    callToAction,
    scrollContainerElementRef,
    widths
  } = t0;
  const [isIntersecting, setIsIntersecting] = useState(true);
  let t1;
  if ($[0] !== (callToAction === null || callToAction === void 0 ? void 0 : callToAction.columnIndex) || $[1] !== (callToAction === null || callToAction === void 0 ? void 0 : callToAction.rowIndex)) {
    t1 = () => {
      Raven.captureException(new Error("FrameworkDataTable columnCallToAction: could not find target cell within 10s"), {
        extra: {
          columnIndex: callToAction === null || callToAction === void 0 ? void 0 : callToAction.columnIndex,
          rowIndex: callToAction === null || callToAction === void 0 ? void 0 : callToAction.rowIndex
        }
      });
    };
    $[0] = callToAction === null || callToAction === void 0 ? void 0 : callToAction.columnIndex;
    $[1] = callToAction === null || callToAction === void 0 ? void 0 : callToAction.rowIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  callToAction === null || callToAction === void 0 || callToAction.columnIndex;
  callToAction === null || callToAction === void 0 || callToAction.rowIndex;
  const onTimeout = t1;
  const t2 = (_callToAction$rowInde = callToAction === null || callToAction === void 0 ? void 0 : callToAction.rowIndex) !== null && _callToAction$rowInde !== void 0 ? _callToAction$rowInde : null;
  const t3 = (_callToAction$columnI = callToAction === null || callToAction === void 0 ? void 0 : callToAction.columnIndex) !== null && _callToAction$columnI !== void 0 ? _callToAction$columnI : null;
  let t4;
  if ($[3] !== onTimeout || $[4] !== scrollContainerElementRef || $[5] !== t2 || $[6] !== t3 || $[7] !== widths) {
    t4 = {
      rowIndex: t2,
      columnIndex: t3,
      scrollContainerElementRef,
      widths,
      maxWaitMs: 10000,
      onTimeout
    };
    $[3] = onTimeout;
    $[4] = scrollContainerElementRef;
    $[5] = t2;
    $[6] = t3;
    $[7] = widths;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    anchorElement
  } = useVirtualizedCellAnchor(t4);
  let t5;
  let t6;
  if ($[9] !== anchorElement || $[10] !== scrollContainerElementRef) {
    t5 = () => {
      const scrollRoot = scrollContainerElementRef.current;
      if (!anchorElement || !scrollRoot) {
        return;
      }
      const observer = new IntersectionObserver(t7 => {
        const [entry] = t7;
        return setIsIntersecting(entry.isIntersecting);
      }, {
        root: scrollRoot,
        threshold: 0
      });
      observer.observe(anchorElement);
      return () => observer.disconnect();
    };
    t6 = [anchorElement, scrollContainerElementRef];
    $[9] = anchorElement;
    $[10] = scrollContainerElementRef;
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  useEffect(t5, t6);
  const isAnchorVisible = anchorElement !== null && isIntersecting;
  let t7;
  if ($[13] !== anchorElement || $[14] !== isAnchorVisible) {
    t7 = {
      anchorElement,
      isAnchorVisible
    };
    $[13] = anchorElement;
    $[14] = isAnchorVisible;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};